import { render, staticRenderFns } from "./LabTestDashboard.vue?vue&type=template&id=270c6fb4&scoped=true&"
import script from "./LabTestDashboard.vue?vue&type=script&lang=js&"
export * from "./LabTestDashboard.vue?vue&type=script&lang=js&"
import style0 from "./LabTestDashboard.vue?vue&type=style&index=0&id=270c6fb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270c6fb4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
